import parse from 'html-react-parser'
import { useCurrencies } from 'mmfintech-backend-api'
import { formatMoney, tr } from 'mmfintech-commons'
import './AmountValue.scss'

interface Props {
  amount: number
  currency: string
  fee?: number
  feeCurrency?: string
}

function AmountValue({ amount, currency, fee, feeCurrency }: Props) {
  const { getCurrencyPrecision } = useCurrencies()

  function formatFee() {
    return `<span data-test="fee-amount">${formatMoney(fee, feeCurrency, getCurrencyPrecision(feeCurrency))}</span>`
  }

  return (
    <div className='amount-value'>
      <div className='amountTitle'>{tr('PORTAL.COMPONENTS.AMOUNT_VALUE.AMOUNT', 'Amount')}</div>
      <span data-test='amount' className='amount'>
        {formatMoney(amount, currency, getCurrencyPrecision(currency))}
      </span>
      {fee > 0 && (
        <div className='amount-value__fee'>
          {parse(tr('PORTAL.COMPONENTS.AMOUNT_VALUE.FEE', 'Fee {{FEE}} included').replace('{{FEE}}', formatFee()))}
        </div>
      )}
    </div>
  )
}

export default AmountValue
